import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManageRwoProblems() {
   const ALL_OPT = { value: 0, label: "-- Select --", active: false };
   const CHILD_OPT = { value: 0, label: "-- Select --", active: false, parent: 0 };
   const CHILD_MODEL = { id: 0, problemId: 0, problem: "", active: true };
   const PBLM_MODEL = { problemId: 0, problem: "", active: true };
   const [childList, setChildList] = useState([]); // child problems unfiltered
   const [childSubs, setChildSubs] = useState([]); // child problems filtered by parent problem id
   const [childProblem, setChildProblem] = useState(CHILD_MODEL);
   const [problemList, setProblemList] = useState([]);
   const [problem, setProblem] = useState(PBLM_MODEL);
   const [filters, setFilters] = useState([
      { filterName: "problem", value: ALL_OPT },
      { filterName: "child", value: CHILD_OPT }
   ]);
   const [editProblem, setEditProblem] = useState("");
   const [editSub, setEditSub] = useState("");
   const [newProblem, setNewProblem] = useState("");
   const [newSub, setNewSub] = useState("");
   const [origProblem, setOrigProblem] = useState("");
   const [origSub, setOrigSub] = useState("");
   const [spinRwoPblm, setSpinRwoPblm] = useState(true);


   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (!childProblem || childProblem.id === 0)
         return; // child was reset to initial state

      if (!editSub || editSub.length < 1)
         return; // Not editing       

      if (childProblem.problem === origSub)
         return; // No change made to child being edited

      if (childProblem.problem.length < 3) { // Do we need this?
         toast.error("Child problem must be at least 3 characters");
         return;
      }
      UpdateChildProblem();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [childProblem])

   useEffect(() => {
      if (!problem || problem.problemId === 0)
         return; // problem was reset to initial state

      if (!editProblem || editProblem.length < 1)
         return; // Not editing       

      if (problem.problem === origProblem)
         return; // No change made to problem being edited

      if (problem.problem.length < 3) { // Do we need this?
         toast.error("Problem must be at least 3 characters");
         return;
      }
      UpdateProblem();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [problem])

   function ActivateChildProblem() {
      if (!childProblem || childProblem.id === 0) {
         toast.error("Please select a child problem to activate");
         return;
      }

      setSpinRwoPblm(true);
      api.post(`Repair/ActivateProblemChild/${childProblem.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Child problem activated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinRwoPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinRwoPblm(false);
         });
   }

   function ActivateProblem() {
      if (!problem || problem.problemId === 0) {
         toast.error("Please select a problem to activate");
         return;
      }

      setSpinRwoPblm(true);
      api.post(`Repair/ActivateProblemType/${problem.problemId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Problem activated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinRwoPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinRwoPblm(false);
         });
   }

   function DeleteChildProblem() {
      setSpinRwoPblm(true);
      api.post(`Repair/DeleteProblemChild/${childProblem.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Child problem was successfully deleted or made inactive!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinRwoPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinRwoPblm(false);
         });
   }

   function DeleteProblem() {
      setSpinRwoPblm(true);
      api.post(`Repair/DeleteProblemType/${problem.problemId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Problem was successfully deleted or made inactive!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinRwoPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinRwoPblm(false);
         });
   }

   const fixChildren = async (id) => {
      let newPblmList = [CHILD_OPT]; // Default option
      var subs = _.pickBy(childList, (e) => _.includes([id], e.parent));
      if (subs) { // There are child problems for the selected problem
         newPblmList = _.concat(
            [CHILD_OPT],
            _.map(subs, (s) => ({ value: s.value, label: s.label, active: s.active, parent: s.parent }))
         );
         setChildSubs(newPblmList);
      }
   };

   function onChildChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      setNewSub("")
      if (newFilterValue.value === 0) { // Clear edit info
         setChildProblem(CHILD_MODEL);
         setOrigSub("");
         setEditSub("");
      }
      else { // Get the child to be edited
         const pblm = _.find(childSubs, (x) => x.value === newFilterValue.value);
         setOrigSub(pblm.label);
         setEditSub(pblm.label);

         let changes = Object.assign({}, CHILD_MODEL);
         changes.id = pblm.value;
         changes.problem = pblm.label;
         changes.active = pblm.active;
         changes.problemId = pblm.parent;
         setChildProblem(changes);
      }
   }

   function onChildUpdate() {
      let changes = Object.assign({}, childProblem);
      changes.problem = editSub
      setChildProblem(changes);
   }

   async function onProblemChange(newFilterValue) {
      // Populate selected problem children & clear lingering values
      await fixChildren(newFilterValue.value);
      setChildProblem(CHILD_MODEL);
      setOrigSub("");
      setEditSub("");
      setNewSub("")
      setNewProblem("");

      // Set the filters to the selected problem and the default child
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      newFilters = filterHelpers.getFilters(newFilters, {
         filterName: "child",
         value: CHILD_OPT,
      });
      setFilters(newFilters);

      if (newFilterValue.value === 0) { // Clear edit info
         setProblem(PBLM_MODEL);
         setOrigProblem("");
         setEditProblem("");
      }
      else { // Get the problem to be edited
         const d = _.find(problemList, (x) => x.value === newFilterValue.value);
         setOrigProblem(d.label);
         setEditProblem(d.label);

         let changes = Object.assign({}, problem);
         changes.problemId = d.value;
         changes.problem = d.label;
         changes.active = d.active;
         setProblem(changes);
      }
   }

   function onProblemUpdate() {
      let changes = Object.assign({}, problem);
      changes.problem = editProblem
      setProblem(changes);
   }

   function runQuery() {
      var active = false; // Indicator of if we only show active problems and their children
      setSpinRwoPblm(true);
      api
         .fetch(`Repair/LoadRwoDropdowns/${active}`)
         .then((response) => {
            //console.log(response.data);
            if (response.data.success) {
               const pList = _.concat([ALL_OPT],
                  _.map(response.data.problems, (p) => ({
                     value: p.problemId,
                     label: p.problem,
                     active: p.active
                  })));
               const subList = _.concat(
                  _.map(response.data.problemSubs, (pSub) => ({
                     value: pSub.id,
                     label: pSub.problem,
                     parent: pSub.problemId,
                     active: pSub.active
                  }))
               );
               return {
                  pList: pList,
                  subList: subList
               };
            } else {
               throw new Error(response);
            }
         })
         .then(({ pList, subList }) => {
            setProblemList(pList);
            setChildList(subList);
            setChildSubs(CHILD_OPT); // This will populate when a parent reason is chosen
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setEditProblem("");
            setOrigProblem("");
            setNewProblem("")
            setEditSub("");
            setOrigSub("");
            setNewSub("")
            setProblem(PBLM_MODEL);
            setChildProblem(CHILD_MODEL);
            setSpinRwoPblm(false);
         });
   }

   function SaveNewChild() {
      if (!newSub || newSub.length < 1) {
         toast.error("Please provide a child problem description");
         return;
      }
      if (newSub.length < 3) {
         toast.error("Child problem description must be at least 3 characters");
         return;
      }
      let payload = CHILD_MODEL;
      payload.problem = newSub;
      payload.problemId = problem.problemId;

      setSpinRwoPblm(true);
      api.post('Repair/SaveProblemChild', payload)
         .then((response) => {
            if (response.data.success) {
               toast.success("Child Problem created!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinRwoPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinRwoPblm(false);
         });
   }

   function SaveNewProblem() {
      if (!newProblem || newProblem.length < 1) {
         toast.error("Please provide a problem description");
         return;
      }
      if (newProblem.length < 3) {
         toast.error("Problem description must be at least 3 characters");
         return;
      }
      let payload = PBLM_MODEL;
      payload.problem = newProblem;

      setSpinRwoPblm(true);
      api.post('Repair/SaveProblemType', payload)
         .then((response) => {
            if (response.data.success) {
               toast.success("Problem created!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinRwoPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinRwoPblm(false);
         });
   }

   function UpdateChildProblem() {
      setSpinRwoPblm(true);
      api.post('Repair/SaveProblemChild', childProblem)
         .then((response) => {
            if (response.data.success) {
               toast.success("Child problem updated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinRwoPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinRwoPblm(false);
         });
   }

   function UpdateProblem() {
      setSpinRwoPblm(true);
      api.post('Repair/SaveProblemType', problem)
         .then((response) => {
            if (response.data.success) {
               toast.success("Problem updated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinRwoPblm(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinRwoPblm(false);
         });
   }

   const ShowDeleteModal = () => {
      if (!problem || problem.problemId === 0) {
         toast.error("Please select a problem");
         return;
      }
      confirmAlert({
         title: "Confirm Problem Deletion",
         message: `Are you sure you want to delete the ${editProblem} problem?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteProblem() } },
            { label: "No" }
         ]
      });
   }

   const ShowDeleteSubModal = () => {
      if (!childProblem || childProblem.id === 0) {
         toast.error("Please select a child problem");
         return;
      }
      confirmAlert({
         title: "Confirm Child Deletion",
         message: `Are you sure you want to delete the ${editSub} child of the selected ${problem.problem} problem?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteChildProblem() } },
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinRwoPblm}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6" width="120px">
                                       New Problem:
                                    </td>
                                    <td className="transparent-background" width="500px">
                                       <Input
                                          type="text"
                                          value={newProblem || ""}
                                          onChange={(e) => setNewProblem(e.target.value)}
                                          maxLength="50"
                                       />
                                    </td>
                                    <td className="transparent-background">
                                       <Button
                                          title="New Problem"
                                          className="shredButtonExcel ms-2"
                                          onClick={() => SaveNewProblem()}
                                       >
                                          Add New Problem
                                       </Button>
                                    </td>
                                 </tr>
                              </tbody>
                           </Table>
                        </Col>
                     </Row>

                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {problemList && problemList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6" width="120px">
                                          Edit Problem:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="problem"
                                             options={problemList}
                                             value={filterHelpers.getValue(filters, "problem")}
                                             onChangeCallback={e => onProblemChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}
                        </Col>
                     </Row>

                     {problem && problem.problemId > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Deleting a problem that has repair work order records attached will set it to inactive.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Inactive problems will not show up when adding a new repair work order.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          Id: {problem.problemId}
                                       </td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Active: {problem.active ? "Yes" : "No"}
                                       </td>
                                       <td colSpan={3} className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Problem:
                                       </td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="text"
                                             value={editProblem || ""}
                                             onChange={(e) => setEditProblem(e.target.value)}
                                             maxLength="50"
                                          />
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Update"
                                             className="shredButton"
                                             onClick={() => onProblemUpdate()}
                                          >
                                             Update
                                          </Button>
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Delete"
                                             className="shredButton"
                                             onClick={() => ShowDeleteModal()}
                                          >
                                             Delete
                                          </Button>
                                       </td>
                                       {!problem.active ? (
                                          <td className="transparent-background data-cell">
                                             <Button
                                                title="Reactivate"
                                                className="shredButton"
                                                onClick={() => ActivateProblem()}
                                             >
                                                Reactivate
                                             </Button>
                                          </td>
                                       ) : <td className="transparent-background data-cell"></td>}
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>

                           {problem.active ? (
                              <div>
                                 <br />
                                 <hr />
                                 <Row className="px-2 py-2">
                                    <Col xxl={{ offset: 0, size: 12 }} className="noWrap h4">
                                       Manage Children for the selected {problem.problem} Problem
                                    </Col>
                                 </Row>
                                 <Row className="px-2 py-2">
                                    <Col xxl={{ offset: 0, size: 12 }}>
                                       <Table className="transparent-background my-0">
                                          <tbody>
                                             <tr>
                                                <td className="transparent-background data-cell noWrap h6" width="120px">
                                                   New Child:
                                                </td>
                                                <td className="transparent-background" width="500px">
                                                   <Input
                                                      type="text"
                                                      value={newSub || ""}
                                                      onChange={(e) => setNewSub(e.target.value)}
                                                      maxLength="50"
                                                   />
                                                </td>
                                                <td className="transparent-background">
                                                   <Button
                                                      title="New Child"
                                                      className="shredButtonExcel ms-2"
                                                      onClick={() => SaveNewChild()}
                                                   >
                                                      Add New Child
                                                   </Button>
                                                </td>
                                             </tr>
                                          </tbody>
                                       </Table>
                                    </Col>
                                 </Row>

                                 <Row className="px-2 py-2">
                                    <Col xxl={{ offset: 0, size: 12 }}>
                                       {childSubs && childSubs.length ? (
                                          <Table className="transparent-background my-0">
                                             <tbody>
                                                <tr>
                                                   <td className="transparent-background data-cell noWrap h6" width="120px">
                                                      Edit Child:
                                                   </td>
                                                   <td className="transparent-background" width="500px">
                                                      <FilterSelect
                                                         filterName="child"
                                                         options={childSubs}
                                                         value={filterHelpers.getValue(filters, "child")}
                                                         onChangeCallback={e => onChildChange(e)}
                                                      />
                                                   </td>
                                                   <td className="transparent-background"></td>
                                                </tr>
                                             </tbody>
                                          </Table>
                                       ) : null}
                                    </Col>
                                 </Row>

                                 {childProblem && childProblem.id > 0 ? (
                                    <div>
                                       <Row className="px-0 py-0">
                                          <Table className="transparent-background data-table">
                                             <tbody>
                                                <tr>
                                                   <td className="transparent-background data-cell width40px"></td>
                                                   <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                                      Deleting a problem child that has repair work order records attached will set it to inactive.
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td className="transparent-background data-cell width40px"></td>
                                                   <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                                      Inactive problem children will not show up when creating repair work orders.
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td className="transparent-background data-cell width40px"></td>
                                                   <td className="transparent-background data-cell width95px noWrap h6">
                                                      Id: {childProblem.id}
                                                   </td>
                                                   <td className="transparent-background data-cell noWrap h6 width115px">
                                                      Active: {childProblem.active ? "Yes" : "No"}
                                                   </td>
                                                   <td colSpan={3} className="transparent-background data-cell"></td>
                                                </tr>
                                                <tr>
                                                   <td className="transparent-background data-cell width40px"></td>
                                                   <td className="transparent-background data-cell noWrap h6 width115px">
                                                      Problem:
                                                   </td>
                                                   <td className="transparent-background data-cell width500px">
                                                      <Input
                                                         type="text"
                                                         value={editSub || ""}
                                                         onChange={(e) => setEditSub(e.target.value)}
                                                         maxLength="50"
                                                      />
                                                   </td>
                                                   <td className="transparent-background data-cell width115px">
                                                      <Button
                                                         title="Update"
                                                         className="shredButton"
                                                         onClick={() => onChildUpdate()}
                                                      >
                                                         Update
                                                      </Button>
                                                   </td>
                                                   <td className="transparent-background data-cell width115px">
                                                      <Button
                                                         title="Delete"
                                                         className="shredButton"
                                                         onClick={() => ShowDeleteSubModal()}
                                                      >
                                                         Delete
                                                      </Button>
                                                   </td>
                                                   {!childProblem.active ? (
                                                      <td className="transparent-background data-cell">
                                                         <Button
                                                            title="Reactivate"
                                                            className="shredButton"
                                                            onClick={() => ActivateChildProblem()}
                                                         >
                                                            Reactivate
                                                         </Button>
                                                      </td>
                                                   ) : <td className="transparent-background data-cell"></td>}
                                                </tr>
                                             </tbody>
                                          </Table>
                                       </Row>
                                    </div>
                                 ) : null}
                              </div>
                           ) : null}
                        </div>
                     ) : null}

                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
